"use client";

import { Laptop, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { TooltipContent } from "./tooltip-content";

export const Themes = ["system", "light", "dark"];

const ICON_SIZE = 20;

export default function ThemeSelector() {
	const { theme, setTheme } = useTheme();
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	// Prevents hydration mismatch
	if (!mounted) return null;

	const getNextTheme = () => {
		const currentIndex = Themes.indexOf(theme || "system");
		const nextIndex = (currentIndex + 1) % Themes.length;
		return Themes[nextIndex];
	};

	const getCurrentIcon = () => {
		switch (theme) {
			case "light":
				return <Sun size={ICON_SIZE} className="text-primary" />;
			case "dark":
				return <Moon size={ICON_SIZE} className="text-primary" />;
			default:
				return <Laptop size={ICON_SIZE} className="text-primary" />;
		}
	};

	return (
		<TooltipContent content="Switch theme">
			<button
				type="button"
				onClick={() => setTheme(getNextTheme())}
				className="p-2 rounded-full hover:bg-primary/20"
				title={`Switch to ${getNextTheme()} theme`}
			>
				{getCurrentIcon()}
			</button>
		</TooltipContent>
	);
}
